import { __awaiter, __generator } from "tslib";
import { getFetchManySubEntitiesUrl } from '../utilities/get-fetch-many-sub-entities-url';
import { fetchGetProductCatalogue } from './fetch-get-product-catalogue';
/**
 * @internal
 */
export var fetchManySubEntities = function (entityIds, subEntityType, productType, includeType) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = getFetchManySubEntitiesUrl(entityIds, subEntityType, productType, includeType);
                return [4 /*yield*/, fetchGetProductCatalogue(url)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
